import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const CanvasIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon viewBox="0 0 28 28" {...props}>
       <path fill="currentColor" d="M18.965 5a2.5 2.5 0 0 1 1.666.73l1.637 1.637c.49.49.733 1.132.732 1.773a2.5 2.5 0 0 1-.73 1.762l-.788.789L10.172 23H4.998v-5.17l.146-.146 1.116-1.117L16.31 6.519l.785-.787A2.5 2.5 0 0 1 18.965 5M6 18.243v3.758h3.758l.616-.616-3.758-3.759zm1.323-1.324 3.759 3.759 9.34-9.34-3.758-3.759zM19.924 6.438a1.5 1.5 0 0 0-2.122 0l-.433.433 3.758 3.758.435-.434a1.5 1.5 0 0 0-.001-2.12z"></path>
    </SvgIcon>
)

export default CanvasIcon
